<template>
  <div class="q-wrap">
    <div class="q-section-hint">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M160-200v-80h640v80H160Zm0-240v-80h640v80H160Zm0-240v-80h640v80H160Z"/></svg>
      Divisor de seccion — no requiere respuesta del registrante
    </div>
    <div class="q-row">
      <label class="q-label">Titulo de la seccion</label>
      <input class="q-input q-input--bold" :class="{ 'q-input--error': question.error }" type="text"
        placeholder="Ej: DATOS DEL BENEFICIARIO" v-model="question.texto" />
      <p v-if="question.error" class="q-error-msg">Ingrese el titulo de la seccion.</p>
    </div>
    <div class="q-row">
      <label class="q-label">Descripción adicional<span>(opcional)</span></label>
      <textarea class="q-input" rows="4" type="text" placeholder="Describe lo que se espera en la respuesta..." v-model="question.descripcion" ></textarea>
    </div>

    <div class="q-row">
      <label class="q-label">Nota <span>(opcional)</span></label>
      <input class="q-input" type="text" placeholder="Escribe una nota corta o definición..." v-model="question.nota_para_registrante" />
    </div>

  </div>
</template>

<script>
export default {
  name: "section-question",
  methods: {
    remove() { this.$emit("click"); },
    validateQuestion() {
      if (this.question.texto === "") { this.question.error = true; return false; }
      this.question.error = false; return true;
    },
  },
  props: { question: { required: true } },
};
</script>

<style scoped>
.q-wrap { display: flex; flex-direction: column; gap: 10px; font-size: 0.82rem; }
.q-section-hint { display: flex; align-items: center; gap: 6px; font-size: 0.7rem; color: #94a3b8; font-style: italic; }
.q-section-hint svg { width: 14px; height: 14px; flex-shrink: 0; }
.q-row { display: flex; flex-direction: column; gap: 4px; }
.q-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #64748b; }
.q-input { width: 100%; padding: 6px 10px; border: 1px solid #cbd5e1; border-radius: 7px; background: #f8fafc; color: #334155; font-size: 0.82rem; transition: border-color 0.15s; outline: none; box-sizing: border-box; }
.q-input--bold { font-weight: 600; font-size: 0.88rem; color: #1e293b; }
.q-input:focus { border-color: #64748b; box-shadow: 0 0 0 3px rgba(100,116,139,0.12); background: #fff; }
.q-input--error { border-color: #f87171 !important; }
.q-error-msg { font-size: 0.7rem; color: #ef4444; margin: 0; }
</style>
